import { render, staticRenderFns } from "./ItemListEditionComponent.vue?vue&type=template&id=6cc7d9b8&scoped=true"
import script from "./ItemListEditionComponent.vue?vue&type=script&lang=js"
export * from "./ItemListEditionComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc7d9b8",
  null
  
)

export default component.exports